const CLOSED = { label: 'Закрыта', color: 'text-positive' }
const OPEN = { label: 'Открыта', color: 'text-warning' }
const HELD_OPEN = { label: 'Осталась открыта', color: 'text-critical' }
const HELD_CLOSED = { label: 'Осталась закрыта', color: 'text-muted-300' }

const hasNumeric = (val) => val !== null && val !== undefined && val !== '' && Number.isFinite(Number(val))

/** Map hikvision_door_status (0–3). Unknown codes (e.g. 4 on some firmware) return null. */
export const doorStatusFromCode = (val) => {
  if (!hasNumeric(val)) return null
  const v = Number(val)
  if (v === 0) return CLOSED
  if (v === 1) return OPEN
  if (v === 2) return HELD_OPEN
  if (v === 3) return HELD_CLOSED
  return null
}

/**
 * Prefer door_status; if the exporter has no code, use magnetic (physical leaf)
 * then lock. Does not invent values when every field is missing.
 */
export const resolveDoorState = (door) => {
  const fromCode = doorStatusFromCode(door?.status)
  if (fromCode) return fromCode
  if (hasNumeric(door?.magnet)) {
    return Number(door.magnet) === 1 ? OPEN : CLOSED
  }
  if (hasNumeric(door?.lock)) {
    return Number(door.lock) === 1 ? OPEN : CLOSED
  }
  return null
}

const isOpenish = (state) => state?.color === 'text-warning' || state?.color === 'text-critical'

/** KPI status for an online controller: worst open-ish door, else a closed state. */
export const kpiDoorStatus = (doors) => {
  const resolved = (doors || []).map((entry) => resolveDoorState(entry?.[1] ?? entry)).filter(Boolean)
  if (!resolved.length) return null
  return resolved.find(isOpenish) || resolved[0]
}
